import request from "@/util/request";

//根据农机code获取作业面积
export function getLdsmmByCodeNjWorkMj(data) {
  return request({
    url: "/api/restful/getLdsmmByCodeNjWorkMj",
    method: "get",
    params: data
  });
}

//根据农机code获取基本信息
export function getLdsmmByCodeNjInfo(data) {
  return request({
    url: "/api/restful/getLdsmmByCodeNjInfo",

    method: "get",
    params: data
  });
}

//根据农机code获取作业清单
export function getLdsmmTaskServiceOrder(data) {
  return request({
    url: "/api/restful/getLdsmmTaskServiceOrder",
    method: "get",
    params: data
  });
}

//农机轨迹
export function getWlwNJGJ(data) {
  return request({
    url: "/api/restful/getWlwNJGJ",
    method: "get",
    params: data
  });
}

// 农机列表
export function getSmartwlMapLdsmmData(type = "nj") {
  return request({
    url: "/api/restful/getSmartwlMapLdsmmData",
    method: "get",
    params: {
      type
    }
  });
}
